import type { Href } from "expo-router";

import { TEST_IDS } from "@/testIdDefinition";
import type { FontAwesome6ProSolidIconName } from "@react-native-vector-icons/fontawesome6-pro";

export type AppNavItem = {
    href: Href;
    /** i18n key under `nav.*` */
    labelKey: "home" | "requests" | "family" | "settings" | "contactUs";
    icon: FontAwesome6ProSolidIconName;
    matchPrefix?: string;
    testId?: string;
    dividerBefore?: boolean;
};

export const APP_NAV_ITEMS: AppNavItem[] = [
    {
        href: "/",
        labelKey: "home",
        icon: "house",
        testId: TEST_IDS[TEST_IDS.HOME_LINK],
    },
    {
        href: "/submissions",
        labelKey: "requests",
        icon: "clipboard-list",
        matchPrefix: "/submissions",
        testId: TEST_IDS[TEST_IDS.REQUESTS_LINK],
    },
    {
        href: "/family",
        labelKey: "family",
        icon: "user-group-simple",
        matchPrefix: "/family",
        testId: TEST_IDS[TEST_IDS.ACCOUNT_LINK],
    },
    {
        href: "/settings",
        labelKey: "settings",
        icon: "gear",
        matchPrefix: "/settings",
        dividerBefore: true,
        testId: TEST_IDS[TEST_IDS.SETTINGS_LINK],
    },
    {
        href: "/contact-us",
        labelKey: "contactUs",
        icon: "phone",
        matchPrefix: "/contact-us",
        testId: TEST_IDS[TEST_IDS.CONTACT_US_LINK],
    },
];

const ACCOUNT_PROFILE_PREFIX = "/profile";

export function isAppNavItemActive(
    pathname: string,
    item: AppNavItem,
): boolean {
    const prefix = item.matchPrefix ?? String(item.href);

    if (prefix === "/") {
        return pathname === "/" || pathname === "";
    }

    if (prefix === "/family") {
        return (
            pathname === prefix ||
            pathname.startsWith(`${prefix}/`) ||
            pathname === ACCOUNT_PROFILE_PREFIX ||
            pathname.startsWith(`${ACCOUNT_PROFILE_PREFIX}/`)
        );
    }

    return pathname === prefix || pathname.startsWith(`${prefix}/`);
}
